module.exports = __webpack_public_path__ + "static/media/pf.d0079d5a.svg";